import React, { FC, useState } from "react";
import PrimaryButton from "../../../components/Buttons/PrimaryButton/PrimaryButton";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { PlusOutlined } from "@ant-design/icons";
import Search from "../../../components/Inputs/Search/Search";
import { columns, data } from "./data";
import CustomBreadCrumb from "../../../components/CustomBreadCrumb/CustomBreadCrumb";
import { Link } from "react-router-dom";
import Selector from "../../../components/Selector/Selector";
import FormItem from "antd/es/form/FormItem";
import TextInput from "../../../components/Inputs/TextInput/TextInput";
import { Card } from "antd";
import CustomCheckbox from "../../../components/CustomCheckbox/CustomCheckbox";
import TextArea from "antd/es/input/TextArea";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import SwitchBtn from "../../../components/Buttons/SwitchBtn/SwitchBtn";
import { useTranslation } from "react-i18next";

const { Dragger } = Upload;
interface CreateRewardProps {}

const CreateReward: FC<CreateRewardProps> = ({}) => {

  const { t } = useTranslation();
  const [dataCopy, setDataCopy] = useState<typeof data>(data);

  const handleSearch = (value: string) => {
    const regex = new RegExp(value, "i");
    console.log(data);
    const temp: typeof data = data.filter((user: any) => {
      return user.email ? regex.test(user.email) : false;
    });
    setDataCopy(temp);
  };
  return (
    <div className="p-4 mt-2 createRewardWrapper">
      <div>
        {/* <h4>{t("journeysViewDataLabel")}</h4> */}
        <CustomBreadCrumb
          items={[
            {
              title: <Link to="/dashboard/loyalty/rewards">{t("listRewardsLabel")} </Link>,
            },

            {
              title: (
                <Link to="/dashboard/loyalty/rewards/create">{t("addRewardLabel")} </Link>
              ),
            },
          ]}
        />
      </div>
      <div className="mt-4 mb-2 ">
        <h6> {t("typesOfRewardLabel")}</h6>
      </div>
      <div className="p-4 reward-section-container">
        <div className="d-flex gap-4">
          <Card className="mb-4 reward-type-card">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-column">
                <span className="font-weight-bold mb-2 reward-label-bold">
                  {t("materialRewardLabel")}
                </span>
                <span>{t("materialRewardDesc")}</span>
              </div>
              <CustomCheckbox checked />
            </div>
          </Card>
          <Card className="mb-4 reward-type-card">
            <div className="d-flex justify-content-between">
              <div className="d-flex flex-column">
                <span className="font-weight-bold mb-2 reward-label-bold">
                  {t("couponLabel")}
                </span>
                <span>{t("couponDesc")}</span>
              </div>
              <CustomCheckbox />
            </div>
          </Card>
        </div>
        <FormItem>
          <Selector
            placeholder="Wallet type allowed for redumption"
            className="w-100"
            options={[
              {
                value: "Wallet type allowed for redumption",
                label: "Wallet type allowed for redumption",
              },
            ]}
          />
        </FormItem>
        <FormItem>
          <Selector
            placeholder="Reward price in points"
            className="w-100"
            options={[
              {
                value: "Wallet type allowed for redumption",
                label: "Reward price in points",
              },
            ]}
          />
        </FormItem>
      </div>
      <div className="mt-4 mb-2 ">
        <h6>{t("basicSettingsLabel")}</h6>
      </div>
      <div className="p-4 reward-section-container">
        <FormItem>
          <TextInput placeholder="Name" />
        </FormItem>
        <FormItem>
          <TextArea rows={3} placeholder="Description" />{" "}
        </FormItem>
        <div className="d-flex gap-2 align-items-baseline">
          <PlusOutlined />
          <p
            className="reward-translation-label"
          >
            {t("translationLabel")} 
          </p>
        </div>

        <FormItem>
          <Selector
            placeholder="Reward is always available"
            className="w-100"
            options={[
              {
                value: "Wallet type allowed for redumption",
                label: "Reward is always available",
              },
            ]}
          />{" "}
        </FormItem>
        <FormItem>
          <Selector
            placeholder="Reward is always visible"
            className="w-100"
            options={[
              {
                value: "Wallet type allowed for redumption",
                label: "Reward is always visible",
              },
            ]}
          />{" "}
        </FormItem>
        <FormItem>
          <Selector
            placeholder="Available for everone"
            className="w-100 reward-selector-greyed"
            options={[
              {
                value: "Wallet type allowed for redumption",
                label: "Available for everyone",
              },
            ]}
          />{" "}
        </FormItem>
        <FormItem>
          <TextInput type="number" placeholder="Redemption limit" />
        </FormItem>
        <FormItem>
          <TextInput type="number" placeholder="Redemption limit per member" />
        </FormItem>
      </div>
      <div className="mt-4 mb-2 ">
        <h6>{t("additionalSettingsLabel")}</h6>
      </div>
      <div className="p-4 reward-section-container">
        <FormItem>
          <TextArea rows={3} placeholder="Usage instruction" />{" "}
        </FormItem>

        <FormItem>
          <TextArea rows={3} placeholder="Condition description" />{" "}
        </FormItem>

        <FormItem>
          <TextArea rows={3} placeholder="Brand name" />{" "}
        </FormItem>

        <FormItem>
          <TextArea rows={3} placeholder="Brand description" />{" "}
        </FormItem>
        <div className="d-flex gap-2 align-items-baseline">
          <PlusOutlined />
          <p
            className="reward-translation-label"
          >
            {t("translationLabel")}
          </p>
        </div>
        <FormItem>
          <Selector
            placeholder="Category"
            className="reward-type-card"
            options={[
              {
                value: "Wallet type allowed for redumption",
                label: "Category",
              },
            ]}
          />{" "}
        </FormItem>

        <FormItem>
          <Selector
            placeholder="Custom reward attributes"
            className="reward-type-card"
            options={[
              {
                value: "Wallet type allowed for redumption",
                label: "Custom reward attributes",
              },
            ]}
          />{" "}
        </FormItem>
      </div>
      <div className="mt-4 mb-2 ">
        <h6>{t("rewardImageUploadLabel")}</h6>
      </div>
      <div className="p-4 reward-section-container">
        <Dragger className="reward-image-dragger">
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{t("rewardImageUploadLabel")}</p>
          <p className="ant-upload-hint">{t("uploadFormatsHint")}</p>
        </Dragger>
      </div>
      <div className="mt-4 mb-2 ">
        <h6>{t("rewardStatusLabel")}</h6>
      </div>
      <div className="p-4 reward-section-container">
        <FormItem>
          <SwitchBtn />
          <span>{t("activeLabel")}</span>
        </FormItem>
      </div>
      <PrimaryButton
        size="middle"
        type="primary"
        htmlType="submit"
        className="reward-save-btn"
      >
       {t("saveLabel")}
      </PrimaryButton>{" "}
    </div>
  );
};

export default CreateReward;
